import { JsonRpcProvider } from '@ethersproject/providers'
import { DEFAULT_CHAIN_ID, getAddressesForGobblerInstance } from 'config'
import { ArtGobblers__factory } from 'contracts'
import { BigNumber, BigNumberish } from 'ethers'
import { getRpcUrlForChain } from 'web3/chains'

const getGobblerAssignedId = async (gobblerTokenId: BigNumberish, chainId = DEFAULT_CHAIN_ID) => {
  const rpcUrl = getRpcUrlForChain(chainId)
  const jsonRpcPRovider = new JsonRpcProvider(rpcUrl)
  const addresses = getAddressesForGobblerInstance(chainId)

  const gobblerContract = ArtGobblers__factory.connect(addresses.ART_GOBBLERS, jsonRpcPRovider)

  try {
    const [_owner, assignedIdx, emissionMultiple] = await gobblerContract.getGobblerData(
      gobblerTokenId,
    )
    const isRevealed = emissionMultiple > 0
    let assignedIdxOverride = assignedIdx
    const gobblerTokenIdString = gobblerTokenId.toString(10)
    const gobblerTokenIdNum = Number(gobblerTokenIdString)
    if (gobblerTokenIdNum > 9990 && gobblerTokenIdNum < 10000) {
      assignedIdxOverride = BigNumber.from(gobblerTokenId)
    }
    return {
      assignedIdx: isRevealed ? assignedIdxOverride : BigNumber.from(0),
      emissionMultiple,
    }
  } catch (e) {
    console.log('error', e)
    return null
  }
}

const getCleanGobblerName = (name: string) => {
  // get index of the first dash in selected gobbler name
  const indexOf = name.indexOf('–')
  // get gobbler name from the first dash until end
  const gobblerName = name.slice(indexOf + 1)

  return gobblerName
}

export { getGobblerAssignedId, getCleanGobblerName }
